import state from './moduleTunnelsState.js'
import mutations from './moduleTunnelsMutations.js'
import actions from './moduleTunnelsActions.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
